import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var IMG_SIZE = 424;
export var IMG_SIZE_XS = 80;
var pimImage = /s\d{2,}\/origin/i;
var imageScalerFormat = /\/\d{4,}-\d{2,}-\d{2,}\.\w+/;
var pimdamImagePathProcessor = function pimdamImagePathProcessor(path, size) {
  return path.replace(/s3.eu-west-1/, 's3-website-eu-west-1').replace('/origin', "/".concat(size, "x").concat(size, "/origin"));
};
var hybrisImagePathProcessor = function hybrisImagePathProcessor(path, size) {
  var _path$split = path.split('-'),
    _path$split2 = _slicedToArray(_path$split, 3),
    idImgAnPath = _path$split2[0],
    widthAndFileExtension = _path$split2[2];
  var _widthAndFileExtensio = widthAndFileExtension.split('.'),
    _widthAndFileExtensio2 = _slicedToArray(_widthAndFileExtensio, 2),
    fileExtension = _widthAndFileExtensio2[1];
  return "".concat(idImgAnPath, "-").concat(size, "-").concat(size, ".").concat(fileExtension);
};
var isPathHasPimDamFormat = function isPathHasPimDamFormat(path) {
  return pimImage.test(path);
};
var convertImagePathToFitImageSize = function convertImagePathToFitImageSize(path, size) {
  var convertFn = isPathHasPimDamFormat(path) ? pimdamImagePathProcessor : hybrisImagePathProcessor;
  return convertFn(path, size);
};
var isPathValid = function isPathValid(path) {
  return isPathHasPimDamFormat(path) || imageScalerFormat.test(path);
};
export var formatImage = function formatImage(path) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IMG_SIZE;
  return isPathValid(path) ? convertImagePathToFitImageSize(path, size) : path;
};
export var formatMobileImage = function formatMobileImage(path) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IMG_SIZE_XS;
  return isPathValid(path) ? convertImagePathToFitImageSize(path, size) : path;
};